import Repository from './../Repository';

const resource = 'admin/subjects';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    create(payload)     {return Repository.post(`${resource}`, payload);},
    update(payload, id) {return Repository.put(`${resource}/${id}`, payload);},
    delete(id)          {return Repository.delete(`${resource}/${id}`);},
    getFullSubject(payload) {return Repository.get(`${resource}/full`, payload);},
}